/**
 *  TUGAS AKHIR
 */

export default [
  {
    path: "/koordinator-tugas-akhir/keputusan",
    name: "koorta-tugas-akhir-keputusan",
    component: () => import("../../views/koor-ta/Mahasiswa.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Koordinator TA", url: "/submenu/koordinator-tugas-akhir" },
        { title: "Keputusan Tugas Akhir", active: true },
      ],
      pageTitle: "Keputusan Tugas Akhir",
    },
  },

  {
    path: "/koordinator-tugas-akhir/data-tugas-akhir",
    name: "koorta-data-tugas-akhir",
    component: () => import("../../views/koor-ta/DataTugasAkhir.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Koordinator TA", url: "/submenu/koordinator-tugas-akhir" },
        { title: "Data Tugas Akhir", active: true },
      ],
      pageTitle: "Data Tugas Akhir",
    },
  },

  {
    path: "/koordinator-tugas-akhir/peminatan",
    name: "koorta-tugas-akhir-peminatan",
    component: () => import("../../views/koor-ta/Peminatan.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Koordinator TA", url: "/submenu/koordinator-tugas-akhir" },
        { title: "Peminatan", active: true },
      ],
      pageTitle: "Peminatan",
    },
  },

  {
    path: "/koordinator-tugas-akhir/seminar-proposal",
    name: "koorta-tugas-akhir-seminar-proposal",
    component: () => import("../../views/koor-ta/SeminarProposal.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Koordinator TA", url: "/submenu/koordinator-tugas-akhir" },
        { title: "Seminar Proposal", active: true },
      ],
      pageTitle: "Seminar Proposal",
    },
  },

  {
    path: "/koordinator-tugas-akhir/daftar-seminar-proposal",
    name: "koorta-tugas-akhir-daftar-seminar-proposal",
    component: () => import("../../views/koor-ta/DaftarSeminarProposal.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Koordinator TA", url: "/submenu/koordinator-tugas-akhir" },
        { title: "Daftar Seminar Proposal", active: true },
      ],
      pageTitle: "Daftar Seminar Proposal",
    },
  },

  {
    path: "/koordinator-tugas-akhir/seminar-kolokium",
    name: "koorta-tugas-akhir-seminar-kolokium",
    component: () => import("../../views/koor-ta/SeminarKolokium.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Koordinator TA", url: "/submenu/koordinator-tugas-akhir" },
        { title: "Seminar Tugas Akhir", active: true },
      ],
      pageTitle: "Seminar Tugas Akhir",
    },
  },

  {
    path: "/koordinator-tugas-akhir/daftar-seminar-kolokium",
    name: "koorta-tugas-akhir-daftar-seminar-kolokium",
    component: () => import("../../views/koor-ta/DaftarSeminarkolokium.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Koordinator TA", url: "/submenu/koordinator-tugas-akhir" },
        { title: "Daftar Seminar Tugas Akhir", active: true },
      ],
      pageTitle: "Daftar Seminar Tugas Akhir",
    },
  },

  {
    path: "/koordinator-tugas-akhir/seminar-yudisium",
    name: "koorta-tugas-akhir-seminar-yudisium",
    component: () => import("../../views/koor-ta/SeminarYudisium.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Koordinator TA", url: "/submenu/koordinator-tugas-akhir" },
        { title: "Seminar Yudisium", active: true },
      ],
      pageTitle: "Seminar Yudisium",
    },
  },

  {
    path: "/koordinator-tugas-akhir/daftar-seminar-yusidium",
    name: "koorta-tugas-akhir-daftar-seminar-yusidium",
    component: () => import("../../views/koor-ta/DaftarSeminaryusidium.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Koordinator TA", url: "/submenu/koordinator-tugas-akhir" },
        { title: "Daftar Seminar yusidium", active: true },
      ],
      pageTitle: "Daftar Seminar yusidium",
    },
  },

  {
    path: "/koordinator-tugas-akhir/pembimbing",
    name: "koorta-tugas-akhir-pembimbing",
    component: () => import("../../views/koor-ta/DaftarPengajuan.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Koordinator TA", url: "/submenu/koordinator-tugas-akhir" },
        { title: "Pembimbing ", active: true },
      ],
      pageTitle: "Pembimbing",
    },
  },

  {
    path: "/koordinator-tugas-akhir/pembimbing/non-pembimbing",
    name: "koorta-tugas-akhir-non-pembimbing",
    component: () =>
      import("../../views/koor-ta/DaftarPengajuanNonPembimbing.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Koordinator TA", url: "/submenu/koordinator-tugas-akhir" },
        { title: "Pembimbing", url: "/koordinator-tugas-akhir/pembimbing" },

        { title: "Mahasiswa Tanpa Pembimbing", active: true },
      ],
      pageTitle: "Mahasiswa Tanpa Pembimbing",
    },
  },
  {
    path: "/koordinator-tugas-akhir/tugas-akhir/daftar-mahasiswa-pembimbing",
    name: "koorta-tugas-akhir-daftar-mahasiswa-pembimbing",
    component: () =>
      import("../../views/koor-ta/DaftarMahasiswaPembimbing.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Koordinator TA", url: "/submenu/koordinator-tugas-akhir" },
        { title: "Tugas Akhir", url: "/koorta/tugas-akhir" },

        { title: "Daftar Mahasiswa Pembimbing", active: true },
      ],
      pageTitle: "Daftar Mahasiswa Pembimbing",
    },
  },

  {
    path: "/koordinator-tugas-akhir/plot-pembimbing/:tugasAkhirId",
    name: "koorta-tugas-akhir-plot-pembimbing",
    component: () => import("../../views/koor-ta/PlotPembimbing.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Koordinator TA", url: "/submenu/koor-ta" },
        { title: "Tugas Akhir", url: "/koor-ta/tugas-akhir" },
        {
          title: "Pembimbing ",
          url: "/koor-ta/tugas-akhir/pembimbing",
        },
        { title: "Plot Pembimbing ", active: true },
      ],
      pageTitle: "Plot Pembimbing",
    },
  },
];
